import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconQuestionmark: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconQuestionmark"><Path d="M12.0001 15.75C12.0001 11.5 16.2501 12.4327 16.2501 8.77356C16.2501 3.78671 8.86504 3.32802 7.8623 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Circle cx="12" cy="19" r="1" fill="currentColor"/></CentralIconBase>;
});

export default IconQuestionmark;
